module.exports = {"contact":"api/v/1/contact","policy":"api/v/1/policy","whitepaper":"api/v/1/whitepaper/"}


//////////////////
// WEBPACK FOOTER
// ./src/config/endpoints.json
// module id = B5xK
// module chunks = 1